import { useState } from "react";
import { hmin } from "../lib/time";

const EST = [["0.5", "0h 30m"], ["1", "1h 00m"], ["1.5", "1h 30m"], ["2", "2h 00m"], ["2.5", "2h 30m"], ["3", "3h 00m"], ["half", "1st half"],
  ["second_half", "2nd half"], ["fullday", "Full day"], ["custom", "Custom"], ["open", "No estimate"]];
const NAMED = ["half", "second_half", "fullday", "open"];

export const toEstimate = (v) => (NAMED.includes(v) ? { kind: v } : { kind: "hours", hours: Number(v) });

function customProblem(min) {
  if (min < 5) return "At least 0h 05m.";
  if (min > 450) return "More than 7h 30m. Use Full day or split the card.";
  return null;
}

function Custom({ testid, apply, onPick }) {
  const [h, setH] = useState(1);
  const [m, setM] = useState(15);
  const min = h * 60 + m;
  const err = customProblem(min);
  const change = (nh, nm) => { setH(nh); setM(nm); if (!apply) onPick(customProblem(nh * 60 + nm) ? null : { kind: "hours", hours: (nh * 60 + nm) / 60 }); };
  return (
    <div className="est-custom" data-testid={`${testid}-custom-box`}>
      <select className="fld sm" aria-label="Hours" value={h} onChange={(e) => change(Number(e.target.value), m)} data-testid={`${testid}-custom-hours`}>
        {Array.from({ length: 8 }, (_, i) => <option key={i} value={i}>{i}h</option>)}
      </select>
      <select className="fld sm" aria-label="Minutes" value={m} onChange={(e) => change(h, Number(e.target.value))} data-testid={`${testid}-custom-minutes`}>
        {Array.from({ length: 12 }, (_, i) => i * 5).map((x) => <option key={x} value={x}>{String(x).padStart(2, "0")}m</option>)}
      </select>
      {apply && <button type="button" className="btn-ghost sm" disabled={!!err} onClick={() => onPick({ kind: "hours", hours: min / 60 })} data-testid={`${testid}-custom-set`}>Set</button>}
      <span className={err ? "err" : "hint0"} role={err ? "alert" : undefined} data-testid={`${testid}-custom-note`}>{err || `${hmin(min)} · steps of 0h 05m, up to 7h 30m.`}</span>
    </div>
  );
}

export function EstimatePicker({ testid, initial = null, apply = false, onPick }) {
  const [sel, setSel] = useState(initial);
  const pick = (v) => {
    setSel(v);
    if (v === "custom") { if (!apply) onPick({ kind: "hours", hours: 1.25 }); return; }
    onPick(toEstimate(v));
  };
  return (
    <>
      <div className="chips">{EST.map(([v, l]) => (
        <button key={v} type="button" aria-pressed={sel === v} className={`chip-btn ${sel === v ? "on" : ""}`} onClick={() => pick(v)}
          data-testid={`${testid}-${v}`}>{l}</button>))}</div>
      {sel === "custom" && <Custom testid={testid} apply={apply} onPick={onPick} />}
    </>
  );
}

export const isSecondHalf = (t) => t.estimate?.kind === "second_half";

export function EstLabel({ t, className = "" }) {
  if (isSecondHalf(t)) return <b className={`tag-2nd ${className}`} data-testid={`second-half-tag-${t.id}`}>2nd half</b>;
  return null;
}
